import React, { useContext, useEffect, useRef, useState } from 'react';
import ProfilePicture from './ProfilePicture';
import { professionalInfoSchema } from '../../Validations/User';
import { useFormik } from 'formik';
import axios from 'axios';
import InputElement from '../Element/InputElement';
import { Context } from '../../Context/Context';
import { APPROVELIST, ATTORNEYLIST, LICENSED, ORGAPPROVELIST, UNAPPROVELIST, approveUserChangeOrgApi, assistantUsersChangeOrgApi, generateSignedurlApi, isEmailAvailableApi, raiseNotificationApi, sendChangeOrgCodeApi, updateUserApi, updateUserProfessionalApi } from '../../Constants';
import AttorneyProfilePic from './AttorneyProfilePic';
import { ToastContainer, toast } from 'react-toastify';
import FormErrorBanner from '../Element/FormErrorBanner';
import FieldError from '../Element/FieldError';
import PreferenceFields from './PreferenceFields';
import { arraysEqual, validateEmail } from 'Utils';
import { signOut } from 'aws-amplify/auth';
import OrgChangeCode from 'Modals/OrgChangeCode';
import { stateUS } from 'states';

function NewOrgProfile({setActivePanel}) 
{
  
  const {userDetails, setUserDetails, setUpdateLoggedinData, makeApiCallFunc} = useContext(Context);
  const [states, setStates] = useState(stateUS);
  const token = localStorage.getItem("token");
  const [errorMsg, setErrorMsg] = useState({
      case: "",
      state: "",
      profilePic: ""
  });
  const {legalType} = userDetails; 
  const [attorneyError, setAttorneyError] = useState("");
  const attorneyImageRemoveRef = useRef(null);
  const [isEmailAvailable, setIsEmailAvailable] = useState();
const [emailSent, setEmailSent] = useState(false);
const [codeSent, setCodeSent] = useState("");
const [showCodeModal, setShowCodeModal] = useState(false);
const [codeError, setCodeError] = useState("");


   
  const [showMoreLabel, setShowMoreLabel] = useState((!legalType || legalType === LICENSED) ? false : true);
 
  const approveData = (values, imgUrl) => {
      values = {...values, "casePref": casePref, "statePref": statePref};
      const data = {};
      ORGAPPROVELIST.map((item) => { 
                data[item] = {
                  "newValue" : values[item],
                  "oldValue" : userDetails[item]
                }
      });
      data.profilePic = {oldValue : userDetails?.profilePic, newValue: imgUrl || profilePic};
      return data;
  }
  const uploadedProfilePicUrl = async (successCallback) => {
    if(profilePic && profilePic !== userDetails?.profilePic)
    {
      const fileName = new Date().toISOString().replace(/:/g, '-') + userDetails._id;
      const blob = await fetch(profilePic).then((res) => res.blob());
       const imageUrl =  makeApiCallFunc(generateSignedurlApi+fileName,
          {fileType: blob.type},
          async ({data}) => {
            const imguploaded = await fetch(data?.url, {
                method: 'PUT',
                headers: {
                  'Content-Type': blob.type,
                },
                body: blob,
              });
            const imageUrl = data?.url.split('?')[0];
            setProfilePic(imageUrl);
            successCallback(imageUrl);
          },
          (data) => { console.log(data) }
        );
        return imageUrl;
    }
    else
    {
      successCallback()
    }
  }
  const checkIfEmailAvailable = (email) => {
    let isAvailable = false;
    if(email !== null && email !== "" && errors.email === undefined)
    {
        makeApiCallFunc(isEmailAvailableApi, {
            email
          },
          ({data}) => {
            isAvailable = data?.available;
            setIsEmailAvailable(isAvailable);
            return isAvailable;
          },
          (data) => console.log(data),
          null,
          true
          )
    }
    else
    {
        setIsEmailAvailable(null);
        return null;
    }
  }
  const checkIfEmailValid = () => {
    makeApiCallFunc(sendChangeOrgCodeApi,
        {
            email: values.email
        },
        ({data}) => {
            setEmailSent(true);
            setCodeSent(data?.code);
            setShowCodeModal(true);
        },
        (data) => console.log(data),
    )
  }
  const confirmCode = () => {
    if(codeEntered === codeSent)
    {
        setCodeEntered("");
        setShowCodeModal(false);

        uploadedProfilePicUrl(makeApprovalSubmission);
    }
    else
    {
        setCodeError("Invalid code");
    }
}
  const onSubmit = (values,action) => {
    // const approvePostData = approveData(values);
    
    if(!profilePic)
    {
        window.scrollTo(0, 0);
        setApiError("Please upload your profile picture to proceed")
    }
    
    else if(userDetails?.email !== values.email && isEmailAvailable === false)
    {
        window.scrollTo(0, 0);
        setApiError(values.email +" email already associated with another account. Please enter a different email")
    }
    else if(userDetails?.email !== values.email && !validateEmail(values.email))
    {
        window.scrollTo(0, 0);
        setApiError(values.email +" - Please use your work email")
    }
    else if((values.legalType === LICENSED &&(values?.casePref?.length === 0 || values?.statePref?.length === 0)))
    {
      console.log(values)
      window.scrollTo(0, 0);
      values?.casePref?.length === 0  ? setErrorMsg((prev) => { return {...prev, "case" : "Please select atleast one case preference"} }) : setErrorMsg((prev) => { return {...prev, "case" : "" }});
      values?.statePref?.length === 0  ? setErrorMsg((prev) => { return {...prev, "state" : "Please select atleast one state preference"} }) : setErrorMsg((prev) => { return {...prev, "state" : "" }});
     
      setApiError("You need to choose atleast one preference in each category to proceed")
    }
    else
    {
        checkIfEmailValid();
    }
  }
  const makeApprovalSubmission = (imgUrl) => 
  {
      const approvePostData = approveData(values, imgUrl);
      if(values.legalType !== LICENSED)
          {
            makeApiCallFunc(
                assistantUsersChangeOrgApi, 
                {
                    email: userDetails?.email, 
                    newEmail: values.email,
                    newProfile: {...values, "role": 2,  "profilePic" : profilePic, "isUserAssistant": true, user: userDetails._id, verified: false},
                },
                async({data})=>
                {
                    await signOut();
                    console.log(data);
                },function (error) {
                console.log(error)
                //setApiError(error?.response?.data?.message);
            })
      }
      else
      {
        if(Object.entries(approvePostData)?.length)
        {
          makeApiCallFunc(
            updateUserProfessionalApi,
            {toBeApproved : {...approvePostData, user: userDetails._id, "isUserAssistant": false},
            "changeOrg": true,
            user: userDetails._id},
            ({data}) => {
                notifyAdmin(data?.user?._id);

              toast.success("Sent the updated information to admin for approval");
              setIsEmailAvailable(null);
            }
            )
        }
      }
  }
  const notifyAdmin = (userId) => {
      const notificationObj = {
      title : userDetails.verified ? "Account updated" : "Verify the account",
      is_read : false,
      sender: userDetails._id,
      notificationCategory: 0,
      additionalInfo:{
        userId
      },
      type: "1",
      receiver: '0',
      content: (userDetails.verified ? "Account of " + userDetails.firstName + " " + userDetails.lastName + " has been updated. Please review and approve or deny with a solid feedback" :"A new account has been created that needs admin's verification and approval. Head to the Awaiting approval section to verify the details of "+ userDetails.firstName + " " + userDetails.lastName)
    }
    const successCallback = (data) => {
      console.log(data); 
    }
    const errorCallback = (data) => {
        console.log(data);
    }
    makeApiCallFunc(
        raiseNotificationApi, 
        notificationObj, 
        successCallback,
        errorCallback
        )
  }
  const handleFocus = (e) => 
  {
    setApiError("");
  }

   const [apiError, setApiError] = useState("");
   const [profilePic, setProfilePic] = useState(userDetails?.profilePic);
   const [codeEntered, setCodeEntered] = useState("");
   const [casePref, setCasePref] = useState(userDetails?.casePref ? userDetails?.casePref : null);
   const [statePref, setStatePref] = useState(userDetails?.statePref ? userDetails?.statePref :null);

   const initialValue = {
    email:  "",
    firstName :userDetails?.firstName ? userDetails?.firstName : "",
    lastName :userDetails?.lastName ? userDetails?.lastName : "",
    company :  "",
    phoneNumber :userDetails?.phoneNumber ? userDetails?.phoneNumber : "",
    experience : "",
    legalType :userDetails?.legalType? userDetails?.legalType: "",
    linkedin: userDetails?.linkedin ? userDetails?.linkedin : "",
    lawFirmLink: "",
    // casePref : casePref,
    // statePref : statePref,
}
   const {values, errors, touched, handleBlur, setFieldValue,handleChange, handleSubmit, isSubmitting} = useFormik({
      enableReinitialize: true,
      initialValues : initialValue,
      validationSchema : professionalInfoSchema,
      onSubmit,
  })
   
  
  return (
    <div className='lg:p-10  p-2 w-full bg-white'>
        {
            emailSent && codeSent &&
            <OrgChangeCode 
             uploadNew = {showCodeModal}
             onClose = {() => setShowCodeModal(false)}
             confirmCode = {confirmCode}
             resendCode = {checkIfEmailValid}
            apiError = {codeError}
            setApiError = {setCodeError}
            confirmationCode = {codeEntered}
            setConfirmationCode = {setCodeEntered}
            />
        }
      
      <FormErrorBanner>{apiError}</FormErrorBanner>
      {
        isEmailAvailable === false ?  
        <FieldError>{values.email} email already associated with another account. Please enter a different email</FieldError>
        :
        isEmailAvailable === true &&
        <p className="text-green-600  p-1 px-2 text-sm font-bold rounded w-max mb-5 mt-2 text-left">{values.email} email is available</p>
      }
          <div className='w-full border-[1px] border-sky-500 mt-10 mb-10 lg:p-10 p-4'>
        <div className='w-full font-medium text-sky-600 mb-4'>New law firm details</div>
        <div className='flex items-center  flex-col lg:flex-row mb-2'>
            <div className='w-full mr-2'>
            <InputElement 
                    handleChange={handleChange}
                    handleBlur={(e) => {handleBlur(e); checkIfEmailAvailable(e.target.value)}}
                    handleFocus={handleFocus}
                    handleKeyUp={() => setIsEmailAvailable(null)}
                    label = "New work Email"
                    name = "email"
                    disabled = "true"
                    placeholder= "Your work email (Required)"
                    value = {values.email}
                    labelError={errors.email}
                    labelTouched={touched.email}
                />
            </div>
          <div className=' lg:mr-2 w-full'>
              <InputElement 
                  handleChange={handleChange}
                  handleBlur={handleBlur}
                  handleFocus={handleFocus}
                  placeholder = "Law firm link (Required)"
                  name = "lawFirmLink"
                  label= "Law firm link"
                  value = {values.lawFirmLink}
                  labelError={errors.lawFirmLink}
                  labelTouched={touched.lawFirmLink}
                />
          </div>
        </div>


        <div className='flex items-center  flex-col lg:flex-row mb-2'>
            
          <div className=' lg:mr-2 w-full'>
              <InputElement 
                  handleChange={handleChange}
                  handleBlur={handleBlur}
                  handleFocus={handleFocus}
                  placeholder = "What law firm do you work for ? (Required)"
                  name = "company"
                  label= "Name of the firm"
                  value = {values.company}
                  labelError={errors.company}
                  labelTouched={touched.company}
                />
          </div>
          <div className='w-full'>
            <InputElement 
                handleChange={handleChange}
                handleBlur={handleBlur}
                handleFocus={handleFocus}
                label = "Work experience"
                name = "experience"
                placeholder= "Your total work experience.(Optional)"
                value = {values.experience}
                labelError={errors.experience}
                labelTouched={touched.experience}
              />
          </div>
        </div>
        
       
      </div> 
      <div className='font-medium mb-10 text-sm text-sky-600 underline'>You shall retain the following information or edit as per your choice.</div>
      <ProfilePicture setProfilePic={setProfilePic} setApiError = {setApiError}  errorMsg={errorMsg} setErrorMsg={setErrorMsg}/>
      
      <div className='flex w-full flex-col lg:flex-row mb-2  border-t-[1px] border-sky-600 mt-10 pt-10' >
        
        <div className='w-full'>
          <InputElement
              handleChange={(e) => {handleChange(e)}}
              handleBlur={handleBlur}
              handleFocus={handleFocus}
              label = "First name"
              name = "firstName"
              placeholder= "First name (Required)"
              value = {values.firstName}
              labelError={errors.firstName}
              labelTouched={touched.firstName}
          />
        </div>
        <div className='w-full lg:ml-2'>
          <InputElement 
                handleChange={handleChange}
                handleBlur={handleBlur}
                handleFocus={handleFocus}
                label = "Last name"
                name = "lastName"
                placeholder= "Last name (Required)"
                value = {values.lastName}
                labelError={errors.lastName}
                labelTouched={touched.lastName}
            />
        </div>
      </div>
      <div className='flex'>
      <div className='w-full'>
            <InputElement 
                handleChange={handleChange}
                handleBlur={handleBlur}
                handleFocus={handleFocus}
                label = "LinkedIn URL"
                name = "linkedin"
                placeholder= "LinkedIn URL(Optional)"
                value = {values.linkedin}
                labelError={errors.linkedin}
                labelTouched={touched.linkedin}
              />
          </div>
        
        <div className=' w-full'>
           <InputElement 
                handleChange={handleChange}
                handleBlur={handleBlur}
                handleFocus={handleFocus}
                label = "Phone Number"
                name = "phoneNumber"
                placeholder= "(123)-456-7890 (Optional)"
                value = {values.phoneNumber}
                labelError={errors.phoneNumber}
                labelTouched={touched.phoneNumber}
              />
            
        </div>
      </div>
  
      {
        !showMoreLabel &&
      <div className='w-full border-t-[1px] border-t-sky-500  pt-10'>
        <div className='w-full font-medium mb-2'>Preferences -
        <span className='font-normal text-xs bg-gray-200'> The cases will be shown based on the preferences, set.</span>
        
        </div>

        <PreferenceFields states={states}
        casePref={casePref}
        statePref={statePref}
        setCasePref={setCasePref}
        setStatePref={setStatePref}
        errorMsg={errorMsg}
        setErrorMsg={setErrorMsg}
        />
       
        
      </div> 
      }
        <div className='flex font-medium justify-between mt-5'>
              <div 
                className="w-auto px-5 h-10 bg-sky-500 hover:bg-sky-600 text-white rounded mt-5 flex justify-center items-center cursor-pointer shadow-xl"
                onClick={handleSubmit}>
                  {userDetails.verified ? 
                  "Submit details for approval"
                  :
                  "Submit"
                  }
                  </div>
              <div 
              className="w-auto px-5 h-10 bg-gray-400 hover:bg-gray-600 text-white rounded mt-5 flex justify-center items-center cursor-pointer shadow-xl"
              onClick={()=>setActivePanel(0)} >Back</div>
        </div>
    </div>
   
  )
}

export default NewOrgProfile